import { render, staticRenderFns } from "./PostsCategorized.vue?vue&type=template&id=43927d80"
import script from "./PostsCategorized.vue?vue&type=script&lang=js"
export * from "./PostsCategorized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports